/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Assign_Track_DInputs */



/**
* | output |
* | --- |
* | "Assign Track D" |
*
* @param {Shortcut_Keys_Name_Assign_Track_DInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_assign_track_d = /** @type {((inputs?: Shortcut_Keys_Name_Assign_Track_DInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Assign_Track_DInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribuer la piste D")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gleis D zuweisen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegna la traccia D")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначить дорожку D")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignar vía D")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分配轨道 D")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックDを割り当てる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक D असाइन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribuir faixa D")
	return /** @type {LocalizedString} */ ("Assign Track D")
});